import axios from '@fs/zion-axios'
import { i18n } from '@fs/zion-locale'

export function getDynamicLinks(queryParams = {}) {
  const params = new URLSearchParams(queryParams).toString()
  const baseUrl = `/service/home/utils/chef/footer?lang=${i18n.language}`
  const url = params ? `${baseUrl}&${params}` : baseUrl
  return axios.get(url).then((response) => response.data)
}
